import React from 'react';
import { SystemText } from '@salesperformanceint/e4shared';
import Panel from 'components/general/panel';
import FocusTile from 'views/user/1-2-1s/components/performanceDashboard/components/focusTile';

export const CaughtUp = ({ focus, data, setShow }) => {
    const message = SystemText('Home/Widgets/WhatsHappening/CaughtUpTeam');

    if (focus) return <FocusTile tileType="review" colour="yellow" icon="fa-users" message={message} />;

    return null;
};

export default CaughtUp;
